import React, { FC, useEffect } from 'react';
import { Box } from '@wix/design-system';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import useMobileTemplatePageTabs, {
  TEMPLATE_PAGE_TABS,
  TemplatePageTabID,
} from './useMobileTemplatePageTabs';
import TemplatePageHeader from '../TemplatePageHeader';
import SellerTab from './SellerTab';
import ReviewsTab from './ReviewsTab';
import AboutTab from './AboutTab';
import StickyTabsNavBar from './StickyTabsNavBar';
import AdditionalInfo from '../AdditionalInfo';
import MobileHero from '../Hero/MobileHero';
import PurchaseErrorNotification from '../PurchaseErrorNotification';

interface Props {
  purchaseError: boolean;
  setPurchaseError: (isError: boolean) => void;
}

const MobileTemplatePage: FC<Props> = ({ purchaseError, setPurchaseError }) => {
  const { activeTabId, setActiveTabId, tabItems } = useMobileTemplatePageTabs();
  const { template } = useTemplateContext();

  const tabContent: Record<TemplatePageTabID, JSX.Element> = {
    [TEMPLATE_PAGE_TABS.about.id]: <AboutTab />,
    [TEMPLATE_PAGE_TABS.reviews.id]: <ReviewsTab />,
    [TEMPLATE_PAGE_TABS.seller.id]: <SellerTab />,
  };

  useEffect(() => {
    const hasOpenModalParam = new URLSearchParams(window.location.search).has(
      'showModal',
    );
    if (hasOpenModalParam) {
      setActiveTabId(TEMPLATE_PAGE_TABS.reviews.id);
    }
  }, []);

  return (
    <Box direction="vertical">
      <Box direction="vertical">
        <TemplatePageHeader isMobile={true} />
        <PurchaseErrorNotification
          isError={purchaseError}
          setPurchaseError={setPurchaseError}
          isMobileView={true}
        />
        <MobileHero setPurchaseError={setPurchaseError} />
        <StickyTabsNavBar
          setPurchaseError={setPurchaseError}
          activeTabId={activeTabId}
          setActiveTabId={setActiveTabId}
          tabItems={tabItems}
        />

        <Box padding="0 24px">{tabContent[activeTabId]}</Box>
      </Box>
      <Box direction="vertical">
        <AdditionalInfo isMobileView={true} />
      </Box>
    </Box>
  );
};

export default MobileTemplatePage;
